var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChats = function SvgChats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M12.5 11.458a.833.833 0 1 1 0 1.666H10a.833.833 0 1 1 0-1.666zM12.5 8.126a.833.833 0 1 1 0 1.666h-5a.833.833 0 1 1 0-1.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M10 2.292a7.5 7.5 0 0 1 7.5 7.5v4.242c0 .343 0 .638-.015.881-.015.25-.05.5-.143.75a2.5 2.5 0 0 1-1.469 1.469c-.25.093-.5.128-.75.143-.243.015-.539.015-.88.015H10a7.5 7.5 0 0 1 0-15m0 1.666a5.834 5.834 0 0 0 0 11.667h4.242c.363 0 .598 0 .777-.012a1 1 0 0 0 .272-.04.83.83 0 0 0 .49-.49 1 1 0 0 0 .04-.271c.011-.18.012-.415.012-.778V9.792A5.834 5.834 0 0 0 10 3.958",
    clipRule: "evenodd"
  })));
};
export default SvgChats;